import { render, staticRenderFns } from "./DocumentNumberList.vue?vue&type=template&id=7b4fc465&"
import script from "./DocumentNumberList.vue?vue&type=script&lang=ts&"
export * from "./DocumentNumberList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports